export default __webpack_public_path__ + "static/media/city.28d294ba.png";